import { SelectableItem } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

enum painScale {
  WITHOUT_MOVEMENT = 1,
  WITH_PARTIAL_FLEXION = 2,
  WITH_FULL_FLEXION_AND_FINGER_FLEXION = 3,
  PERMANENT_RETRACTION = 4,
}

export const upperLimbsData: SelectableItem[] = [
  {
    key: String(painScale.WITHOUT_MOVEMENT),
    label: MessageService.translate('text.without-movement'),
    value: String(painScale.WITHOUT_MOVEMENT),
  },
  {
    key: String(painScale.WITH_PARTIAL_FLEXION),
    label: MessageService.translate('text.with-partial-flexion'),
    value: String(painScale.WITH_PARTIAL_FLEXION),
  },
  {
    key: String(painScale.WITH_FULL_FLEXION_AND_FINGER_FLEXION),
    label: MessageService.translate('text.with-full-flexion-and-finger-flexion'),
    value: String(painScale.WITH_FULL_FLEXION_AND_FINGER_FLEXION),
  },
  {
    key: String(painScale.PERMANENT_RETRACTION),
    label: MessageService.translate('text.permanent-retraction'),
    value: String(painScale.PERMANENT_RETRACTION),
  },
]
